











import { Component, Vue, Prop } from 'vue-property-decorator';
import i18n from '@/i18n';
import saveFile from '@/utils/save-file';

type Query = any; // eslint-disable-line @typescript-eslint/no-explicit-any
type QueryResults = any; // eslint-disable-line @typescript-eslint/no-explicit-any
type Variables = any; // eslint-disable-line @typescript-eslint/no-explicit-any

@Component
export default class DownloadBase64FileButton extends Vue {
  @Prop({ type: Object, required: true }) private query!: Query;
  @Prop([ Object, Function ]) private variables?: Variables | (() => Variables);
  @Prop({ type: Function, required: true }) private dataGetter!: ((data: QueryResults) => string | null);

  @Prop({ type: String, required: true }) private fileName!: string;
  @Prop({ type: String, required: true }) private mimeType!: string;

  @Prop({ type: String, default: 'download' }) private icon!: string;
  @Prop({ type: String, default: i18n.t('pleaseWait') }) private loadingMessage!: string;

  private loading = false;

  private downloadFile() {
    this.loading = true;
    const pleaseWaitMessage = this.$sMessage.warning(this.loadingMessage, { duration: 0 });

    this.$apollo.query({
      query: this.query,
      fetchPolicy: 'no-cache',
      variables: this.variables,
    }).then(({ data }) => {
      this.$sMessage.close(pleaseWaitMessage.id);

      const base64File = this.dataGetter(data);

      if (base64File) {
        saveFile(base64File, this.fileName, this.mimeType);
      } else {
        // i18n.t used instead of this.$t because function is async and component calling it might be destroyed, making 'this' undefined
        this.$sMessage.error(i18n.t('GQL.Model.ValidationType.failed'));
      }
    }).finally(() => {
      this.loading = false;
    });
  }
}
